import { useEffect, useState } from 'react';

export const useDelayedLoading = (isLoading: boolean, delay = 200): boolean => {
  const [showLoading, setShowLoading] = useState(false);

  useEffect(() => {
    if (!isLoading) {
      setShowLoading(false);
      return;
    }

    const timeout = setTimeout(() => setShowLoading(true), delay);

    return (): void => clearTimeout(timeout);
  }, [delay, isLoading]);

  return showLoading;
};
